import { render, staticRenderFns } from "./home-pinglun.vue?vue&type=template&id=0ccdc13b&"
import script from "./home-pinglun.vue?vue&type=script&lang=js&"
export * from "./home-pinglun.vue?vue&type=script&lang=js&"
import style0 from "./home-pinglun.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports